import { Factory } from 'rosie';

Factory.define('Floorboard').attr('name', 'FLOORBOARD');



// WEBPACK FOOTER //
// ./factories/location/floorboard.js